// src/SwitchCatalogData.js
// Detailed switch information object

const SwitchInfos = {
  'u4t': {
    stemMaterial: 'POM',
    topHousing: 'PA66',
    bottomHousing: 'PA66',
    springWeight: 62,
    springLength: 19.5,
    totalTravel: 3.7,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'mxblack': {
    stemMaterial: 'POM',
    topHousing: 'Nylon',
    bottomHousing: 'Nylon',
    springWeight: "55g",
    springLength: 22,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '/audio/encore/encore_mx2a2.mp3',
    link: 'https://unikeyboards.com/products/cherry-mx2a-black-linear-switch-10pcs?sca_ref=9159805.HnviW9XZM5'
  },
  'nixie': {
    stemMaterial: 'POM',
    topHousing: 'Nylon',
    bottomHousing: 'Nylon',
    springWeight: "50g",
    springLength: 22,
    totalTravel: 4.0,
    soundtest1: '/audio/neo65cu/neo65cu_nixie.mp3',
    soundtest2: '',
    link: 'https://milktooth.com/products/nixie'
  },
  'doom': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 63.5,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'milky_yellow': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 62,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'smoothie': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 50,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'caramel_latte': {
    stemMaterial: 'POM',
    topHousing: 'POK',
    bottomHousing: 'PA66 + 30% fiberglass',
    springWeight: "55±5g",
    springLength: 22,
    totalTravel: 3.6,
    soundtest1: '',
    soundtest2: '/audio/encore/encore_caramel_latte.mp3',
    link: 'https://unikeyboards.com/products/huano-caramel-latte-linear-switch-factory-lubed-10pcs?sca_ref=9159805.HnviW9XZM5'
  },
  'cloud': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 50,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'cheese': {
    stemMaterial: 'LY',
    topHousing: 'PA12',
    bottomHousing: 'PA-2',
    springWeight: "46g",
    springLength: 22,
    totalTravel: 3.5,
    soundtest1: '/audio/neo65cu/neo65cu_cheese.mp3',
    soundtest2: '',
    link: 'https://milktooth.com/products/cheese'
  },
  'hyacinth_v2': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 52,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'macchiato': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 50,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'sugar_rush': {
    stemMaterial: 'POM',
    topHousing: 'PA12',
    bottomHousing: 'PA-2 (Same as Cheese)',
    springWeight: "55±2g",
    springLength: 22,
    totalTravel: 3.6,
    soundtest1: '/audio/neo65cu/neo65cu_sugar_rush.mp3',
    soundtest2: '',
    link: 'https://unikeyboards.com/products/unikeys-x-hmx-sugar-rush-linear-switch-factory-lubed-edition-10pcs?sca_ref=9159805.HnviW9XZM5'
  },
  'sunset_gleam': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 48,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'xinhai': {
    stemMaterial: 'POM',
    topHousing: 'PA12',
    bottomHousing: 'Modified Nylon',
    springWeight: "45g",
    springLength: 22,
    totalTravel: 3.4,
    soundtest1: '/audio/neo65cu/neo65cu_xinhai.mp3',
    soundtest2: '/audio/encore/encore_xinhai.mp3',
    link: 'https://unikeyboards.com/products/hmx-xinhai-linear-switch-factory-lubed-edition-10pcs?sca_ref=9159805.HnviW9XZM5'
  },
  'yogurt': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'P5 (40-45% fiberglass)',
    springWeight: "52±2g",
    springLength: 22,
    totalTravel: 3.4,
    soundtest1: '/audio/neo65cu/neo65cu_yogurt.mp3',
    soundtest2: '',
    link: 'https://unikeyboards.com/products/hmx-yogurt-linear-switch-factory-lubed-edition-10pcs?sca_ref=9159805.HnviW9XZM5'
  },
  'purple_dawn': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 58,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'uni': {
    stemMaterial: 'U4 UPE',
    topHousing: 'PA12',
    bottomHousing: 'PA12',
    springWeight: "52±5g",
    springLength: 21,
    totalTravel: 3.7,
    soundtest1: '/audio/neo65cu/neo65cu_kguni.mp3',
    soundtest2: '',
    link: ''
  },
  'y1x': {
    stemMaterial: 'Y1',
    topHousing: 'PA66 with no fiberglass',
    bottomHousing: 'PBT + 30% fiberglass',
    springWeight: "53±5g",
    springLength: 20,
    totalTravel: 3.6,
    soundtest1: '/audio/neo65cu/neo65cu_y1x.mp3',
    soundtest2: '/audio/encore/encore_y1x.mp3',
    link: 'https://unikeyboards.com/products/keygeek-y1x-linear-switch-factory-lubed-10pcs?sca_ref=9159805.HnviW9XZM5'
  },
  'y3': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 53,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'mz_z1': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 53,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'poro': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 50,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'cosmic_purple': {
    stemMaterial: 'POM',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: 55,
    springLength: 15.6,
    totalTravel: 4.0,
    soundtest1: '',
    soundtest2: '',
    link: ''
  },
  'lunar_stone': {
    stemMaterial: 'POM',
    topHousing: 'POM',
    bottomHousing: 'POM',
    springWeight: "55±2g",
    springLength: 22,
    totalTravel: 3.6,
    soundtest1: '',
    soundtest2: '/audio/encore/encore_lunar_stone.mp3',
    link: ''
  },
  'yuying_linear': {
    stemMaterial: 'POM',
    topHousing: 'PA66',
    bottomHousing: 'PA66',
    springWeight: "55±2g",
    springLength: 19.5,
    totalTravel: 3.7,
    soundtest1: '/audio/wingtree/neo65cu_yuying_linear.mp3',
    soundtest2: '',
    link: 'https://unikeyboards.com/products/wingtree-yuying-linear-switch-factory-lubed-10pcs?sca_ref=9159805.HnviW9XZM5'
  },
  'yuying_tactile': {
    stemMaterial: 'POM',
    topHousing: 'PA66',
    bottomHousing: 'PA66',
    springWeight: "58±2g",
    springLength: 19,
    totalTravel: 3.7,
    soundtest1: '/audio/wingtree/neo65cu_yuying_tactile.mp3',
    soundtest2: '',
    link: 'https://unikeyboards.com/products/wingtree-yuying-light-tactile-switch-factory-lubed-10pcs?sca_ref=9159805.HnviW9XZM5'
  },
  'yunie_linear': {
    stemMaterial: 'UPE',
    topHousing: 'PC',
    bottomHousing: 'PA66',
    springWeight: "50±2g / 60±2g",
    springLength: 21,
    totalTravel: 3.5,
    soundtest1: '/audio/wingtree/neo65cu_yunie_linear.mp3',
    soundtest2: '',
    link: 'https://unikeyboards.com/products/wingtree-yunie-linear-switch-factory-lubed-10pcs?sca_ref=9159805.HnviW9XZM5'
  },
  'yunie_tactile': {
    stemMaterial: 'UPE',
    topHousing: 'PC',
    bottomHousing: 'PC',
    springWeight: "60±2g / 63.5±2g",
    springLength: 20.5,
    totalTravel: 3.2,
    soundtest1: '/audio/wingtree/neo65cu_yunie_tactile.mp3',
    soundtest2: '',
    link: 'https://unikeyboards.com/products/wingtree-yunie-tactile-switch-factory-lubed-10pcs?sca_ref=9159805.HnviW9XZM5'
  }
};

export default SwitchInfos;